// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gjTm","content":"styles_content__3-an6"};